import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  Input,
  Box,
  Button,
  Text,
  Heading,
} from "@chakra-ui/react";
import { v4 as uuidv4 } from "uuid";
import { getEndpoint, getOptions } from "../constants/api";

export default function AdminDashboard() {
  const [viewCentres, setViewCentres] = useState([]);
  const [newName, setNewName] = useState("");

  // -- Stream settings state --
  const [streamTitle, setStreamTitle] = useState("");
  const [streamSrc, setStreamSrc] = useState("");

  // -------------------------------
  // CREATE NEW VIEWING CENTER
  // -------------------------------
  function newCentre(name) {
    const center = {
      name: name,
      password: uuidv4(),
      remember: "",
      ip: "",
    };
    newCenter(center);
  }

  const newCenter = async (data) => {
    const options = getOptions(data);
    const endpoint = getEndpoint("add/viewcenter");
    try {
      await fetch(endpoint, options);
      getAllCentres();
    } catch (error) {
      console.log(error);
    }
  };

  // -------------------------------
  // GET ALL VIEWING CENTERS
  // -------------------------------
  const getAllCentres = async () => {
    const endpoint = getEndpoint("centres");
    try {
      const res = await fetch(endpoint);
      const info = await res.json();
      setViewCentres(info);
    } catch (error) {
      console.log(error);
    }
  };

  // -------------------------------
  // DELETE A VIEWING CENTER
  // -------------------------------
  const deleteCenter = async (_id) => {
    const endpoint = getEndpoint(`delete/${_id}`);
    try {
      await fetch(endpoint);
      getAllCentres();
    } catch (error) {
      console.log(error);
    }
  };

  // -------------------------------
  // STREAM SETTINGS
  // -------------------------------
  const getStreamSettings = async () => {
    const endpoint = getEndpoint("stream"); // GET /api/stream
    try {
      const res = await fetch(endpoint);
      const data = await res.json();
      setStreamTitle(data.title);
      setStreamSrc(data.src);
    } catch (error) {
      console.log("Fetching stream settings error:", error);
    }
  };

  const updateStreamSettings = async () => {
    const payload = {
      title: streamTitle,
      src: streamSrc,
    };
    const options = getOptions(payload);
    const endpoint = getEndpoint("stream"); // POST /api/stream

    try {
      const res = await fetch(endpoint, options);
      const data = await res.json();
      alert("Stream settings updated!");
    } catch (error) {
      console.log("Update stream settings error:", error);
    }
  };

  // -------------------------------
  // INITIAL LOAD
  // -------------------------------
  useEffect(() => {
    getAllCentres();
    getStreamSettings();
  }, []);

  return (
    <Box padding={["10px", "20px", "40px"]}>
      <Box textAlign="center" marginBottom="20px">
        <Heading textTransform="uppercase" as="h2" size="xl">
          Viewing Centres
        </Heading>
        <Button colorScheme="red" margin="auto" onClick={getAllCentres}>
          Refresh
        </Button>
      </Box>

      <Table variant="simple">
        <TableCaption>Viewing Centers</TableCaption>
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>Password</Th>
            <Th>Device</Th>
            <Th>IP</Th>
            <Th textAlign="center">Remove Center</Th>
          </Tr>
        </Thead>
        <Tbody>
          {viewCentres.map((center) => (
            <Tr key={center._id}>
              <Td>{center.name}</Td>
              <Td>{center._id}</Td>
              <Td>{center.remember}</Td>
              <Td>{center.ip}</Td>
              <Td textAlign="center">
                <Button
                  colorScheme="red"
                  onClick={() => deleteCenter(center._id)}
                >
                  Delete
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
        <Tfoot>
          <Tr>
            <Th>Name</Th>
            <Th>Password</Th>
            <Th>Device</Th>
            <Th>IP</Th>
            <Th textAlign="center">Remove Center</Th>
          </Tr>
        </Tfoot>
      </Table>

      <Box marginTop="20px">
        <Text margin="3px">Add new center:</Text>
        <Input
          placeholder="Name of Center"
          margin="3px"
          onChange={(e) => setNewName(e.target.value)}
        />
        <Button
          colorScheme="blue"
          margin="3px"
          onClick={() => newCentre(newName)}
        >
          Submit
        </Button>
      </Box>

      {/* STREAM SETTINGS SECTION */}
      <Box marginTop="40px" padding="20px" border="1px solid gray" borderRadius="5px">
        <Heading as="h3" size="md" marginBottom="10px">
          Stream Settings
        </Heading>
        <Text>Title</Text>
        <Input
          placeholder="Stream Title"
          value={streamTitle}
          onChange={(e) => setStreamTitle(e.target.value)}
          marginBottom="10px"
        />

        <Text>Stream URL</Text>
        <Input
          placeholder="Stream Source (HLS or YouTube embed link)"
          value={streamSrc}
          onChange={(e) => setStreamSrc(e.target.value)}
          marginBottom="10px"
        />

        <Button colorScheme="teal" onClick={updateStreamSettings}>
          Save Settings
        </Button>
      </Box>
    </Box>
  );
}
